// extracted by mini-css-extract-plugin
export var backToTop = "footer-module--backToTop--b15a2";
export var base = "footer-module--base--ddf1e";
export var footNote = "footer-module--footNote--40911";
export var link = "footer-module--link--3ccde";
export var links = "footer-module--links--c97aa";
export var logo = "footer-module--logo--9ab9c";
export var social = "footer-module--social--912f1";
export var socials = "footer-module--socials--f1eeb";
export var wrapper = "footer-module--wrapper--88066";